import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Container, Row, Col, Form } from 'reactstrap'
import { signInWithEmailAndPassword, GoogleAuthProvider, signInWithPopup } from 'firebase/auth'
import { toast } from 'react-toastify'

import { auth } from '../firebase.config'
import Helmet from '../components/Helmet/Helmet'
import '../styles/login.css'

const Login = () => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  const signIn = async (e) => {
    e.preventDefault()
    setLoading(true)
    try {
      await signInWithEmailAndPassword(auth, email, password)
      toast.success('Welcome back')
      navigate('/checkout')
    } catch (error) { toast.error(error.message) } finally { setLoading(false) }
  }

  const handleGoogle = async () => {
    try { await signInWithPopup(auth, new GoogleAuthProvider()); navigate('/checkout') }
    catch (error) { toast.error(error.message) }
  }

  return (
    <Helmet title='Login'>
      <section className='auth__page'>
        <Container><Row className='align-items-stretch'>
          <Col lg='6' className='auth__intro'><span className='section__eyebrow'>Your account</span><h1>Good to see you again.</h1><p>Sign in to move through checkout, keep your details secure and get help with your order.</p><div className='auth__benefits'><span><i className='ri-check-line'></i> Faster checkout</span><span><i className='ri-check-line'></i> Secure order details</span><span><i className='ri-check-line'></i> Real customer support</span></div></Col>
          <Col lg='6'><div className='auth__card'><h2>Sign in</h2><p className='auth__lead'>Use your email or continue with Google.</p><Form className='auth__form' onSubmit={signIn}><label><span>Email address</span><input type='email' placeholder='you@example.com' value={email} onChange={(e) => setEmail(e.target.value)} required /></label><label><span>Password</span><input type='password' placeholder='Your password' value={password} onChange={(e) => setPassword(e.target.value)} required /></label><button type='submit' className='buy__btn auth__btn' disabled={loading}>{loading ? 'Signing in…' : 'Sign in'}</button><div className='auth__divider'><span>or</span></div><button type='button' onClick={handleGoogle} className='google__btn'><i className='ri-google-fill'></i> Continue with Google</button><div className='guest__hint'><strong>Just exploring?</strong><span>guest@gmail.com / guest123</span></div><p className='auth__switch'>New to Gadget Groove? <Link to='/signup'>Create an account</Link></p></Form></div></Col>
        </Row></Container>
      </section>
    </Helmet>
  )
}

export default Login
